import React from "react";
import Project from "./index";

export function ProjectDleted() {
  return <Project status="Supprimé" />;
}
